import * as _ from "lodash";

export const minimum_characters_for_channel_description = 10;

export const getUserProfile = (profile_pic) => {
    if (profile_pic === null || typeof profile_pic === undefined || (profile_pic !== null && profile_pic.length < 1)) {
        return "https://s3.eu-west-2.amazonaws.com/assets.vuepay.com/Account-icon%403x.png";
    } else {
        if(profile_pic == "https://s3.eu-west-2.amazonaws.com/assets.vuepay.com/"){
            return "https://s3.eu-west-2.amazonaws.com/assets.vuepay.com/Account-icon%403x.png";
        }
        return profile_pic
    }
}

/**
 * @function this method is invoked from places where they need to check if the broadcaster can send an invite to a  viewer or accept a viewer's request
 * @param oneToOneRequestArray
 * @returns {boolean}
 */
export const canBroadcasterAcceptOrSendInvite = (oneToOneRequestArray) => {

    let status = true;

    _.map(oneToOneRequestArray, (request) => {
        if (request.from === "broadcaster") {
            status = false;
        }
    })

    return status;
}